import styled, { css } from "styled-components";

import dropwownArrowIcon from "../../assets/images/TextEditor/dropdown-arrow-down.svg";
import dropwownArrowIconDark from "../../assets/images/TextEditor/dropdown-arrow-down-dark.svg";

import { colors, darkModeColors } from "../../consts";
import WrapperContainer from "../Containers/WrapperContainer";
import { Paragraph2 } from "../Text/Paragraphs";

const CarrettoStyles = css`
  background-image: ${(props) =>
    props?.theme?.darkMode ? `url(${dropwownArrowIconDark})` : `url(${dropwownArrowIcon})`};

  width: 16px;
  height: 16px;

  top: unset;
  right: 4px;

  border: none !important;
`;

const ViewOnlyStyles = css`
  border-color: transparent;

  .wrapper {
    border: none !important;
    background: ${colors.ISABELLINE_DARKER} !important;
  }

  .toolbar {
    ${(props) => !props?.disabledHeaderVisible && `display: none;`}
    background: ${colors.ISABELLINE_DARKER};
    border-bottom-color: ${colors.RAISIN_10};

    .blockType,
    .rdw-option-wrapper {
      background: ${colors.ISABELLINE_DARKER} !important;
    }
  }

  ${(props) =>
    props.small &&
    `
    .editor {
      padding-top: ${props?.disabledHeaderVisible ? "50px" : "14px"};
    }
  `}
`;

export const TextEditorWrapper = styled(WrapperContainer)`
  width: 100%;
  height: 100%;

  ${(props) =>
    props?.small &&
    `
    overflow: hidden;
    border: 1px solid;
    border-color: ${props?.hasError ? colors.ERROR : colors.RAISIN_50};
    border-radius: 8px;
  `}

  .wrapper {
    ${(props) =>
      props?.small &&
      `
      position: relative;
      top: -14px;
    `}

    height: 100%;
    overflow: ${(props) => (props.small ? "visible" : "hidden")};

    ${(props) =>
      !props.small &&
      `
      border: 1px solid;
      border-color: ${props?.hasError ? colors.ERROR : colors.RAISIN_50};
      border-radius: 8px;
    `}
    background: ${darkModeColors.WHITE_RAISIN_100};

    word-break: break-all;

    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    font-family: "Plus Jakarta Sans";
    color: ${darkModeColors.RAISIN_100_WHITE};

    .public-DraftStyleDefault-block {
      margin: 0;
    }
  }

  .toolbar {
    ${(props) =>
      props.small &&
      `
      position: absolute;
      z-index: 10;
      top: 0;
      right: 0;
      left: 0;
    `}

    border: none;
    border-radius: 0;
    border-bottom: 1px solid;
    border-color: ${darkModeColors.RAISIN_80_RAISIN_20};

    background: ${darkModeColors.WHITE_RAISIN_100};

    padding: 8px;

    * {
      transition: 0s all !important;
    }

    > div {
      margin-bottom: 0;
      height: 28px;

      &:after {
        content: "";
        display: block;
        background: ${colors.LIGHT_GRAY};
        height: 20px;
        width: 0.5px;
        margin: 0 4px;
      }

      &:last-child {
        &:after {
          display: none !important;
        }
      }
    }

    .rdw-option-wrapper {
      border: none;
      padding: 0;

      min-width: 28px !important;
      height: 28px;

      background: ${colors.WHITE};
      border-radius: 8px;

      box-shadow: none !important;

      &:hover {
        border-radius: 8px;
        width: 28px;
        height: 28px;

        background: ${darkModeColors.RAISIN_20_TURQUOISE_100};
      }
    }

    .rdw-option-disabled {
      background: ${colors.WHITE} !important;
    }

    .rdw-option-active {
      border-radius: 8px;
      width: 28px;
      height: 28px;

      background: ${darkModeColors.RAISIN_20_TURQUOISE_100};
    }
  }

  .blockType {
    border: none !important;
    border-color: ${colors.OC_GRAY_2} !important;
    border-radius: 0 !important;

    background: ${darkModeColors.WHITE_RAISIN_100};

    a {
      font-size: 14px;
      font-weight: 400;

      text-transform: none;
      opacity: 1 !important;
    }

    height: 28px;
    width: 100px;

    &:hover {
      box-shadow: none;
      background-color: unset;
    }

    &:active {
      box-shadow: none;
      background-color: unset;
    }

    .rdw-dropdown-carettoopen {
      ${CarrettoStyles};
    }

    .rdw-dropdown-carettoclose {
      ${CarrettoStyles};
      transform: scale(1, -1);
    }
  }

  .blockType-dropdown {
    background: ${darkModeColors.WHITE_RAISIN_100};
    outline: 1px solid ${colors.RAISIN_50};
    overflow: hidden;

    border: none;

    border-radius: 8px;
    margin-top: 4px;
    width: 100%;
    min-width: 130px;

    left: -3px;

    & li {
      padding: 0 8px;

      height: 32px;
      min-height: 32px;
      max-height: 32px;

      width: 100%;

      font-size: 14px;
      line-height: 20px;
      text-transform: none;

      &:hover {
        background: ${(props) =>
          props?.theme?.darkMode ? colors.LIGHT_GRAY : "rgba(52, 48, 61, 0.1)"};

        ${(props) => props?.theme?.darkMode && `color: ${colors.RAISIN_100}`};
      }
    }

    .rdw-dropdownoption-active {
      background: ${(props) =>
        props?.theme?.darkMode ? colors.LIGHT_GRAY : "rgba(52, 48, 61, 0.1)"};

      ${(props) => props?.theme?.darkMode && `color: ${colors.RAISIN_100}`};
    }
  }

  .rdw-link-modal {
    width: unset;
    height: unset;

    background: ${darkModeColors.WHITE_RAISIN_100};

    border: ${(props) => props?.theme?.darkMode && `1px solid rgba(110, 110, 116, 0.55)`};
    box-shadow: ${(props) =>
      props?.theme?.darkMode
        ? `0px 4px 4px rgba(0, 0, 0, 0.16)`
        : `0px 6px 6px rgba(237, 238, 241, 0.6)`};

    border-radius: 4px;

    top: 30px;
    left: 0;

    padding: 16px 10px;

    @media screen and (max-width: 1270px) {
      left: unset;
      right: 0;
    }

    @media screen and (max-width: 1080px) {
      left: 0;
      right: unset;
    }

    @media screen and (max-width: 1045px) {
      left: -250%;
    }

    * {
      font-size: 14px !important;
      line-height: 24px;
    }

    & label {
      font-weight: 500;
    }

    & label[for="openLinkInNewWindow"] {
      display: none;
    }

    & input {
      margin-top: 8px;
      margin-bottom: 12px;

      height: 40px;
      width: 222px;

      padding: 4px 12px;
      font-size: 16px !important;
      line-height: 24px;

      border-radius: 8px;
      border: 1px solid ${colors.RAISIN_50};
      color: ${darkModeColors.RAISIN_100_WHITE};
      background: ${darkModeColors.WHITE_RAISIN_100};

      &:hover {
        box-shadow: ${(props) =>
          props?.theme?.darkMode
            ? `0px 4px 4px rgba(255, 255, 255, 0.16)`
            : `0px 4px 4px rgba(52, 48, 61, 0.16)`};
      }

      &:focus {
        outline: none;
        box-shadow: none;
        border: ${(props) =>
          props?.theme?.darkMode
            ? `2px solid ${colors.TURQUOISE_100}`
            : `2px solid ${colors.RAISIN_100}`};
      }

      &:placeholder {
        color: ${colors.IRON};
      }
    }

    .rdw-link-modal-buttonsection {
      margin: 0;

      width: 100%;
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-start;

      gap: 8px;

      button {
        height: 40px;
        width: 87px;

        margin: 0;
        border-radius: 100px;

        cursor: pointer;

        font-weight: 600;
        font-size: 16px;
        line-height: 24px;

        box-shadow: none !important;

        transition: 0.5s all;

        background: transparent;
        color: ${darkModeColors.RAISIN_100_ISABELLINE};

        border: 1px solid;
        border-color: ${darkModeColors.RAISIN_100_ISABELLINE};

        &:hover {
          opacity: 1;

          background: ${darkModeColors.ISABELLINE_DARKER_RAISIN_80};
        }

        &:active {
          background: ${darkModeColors.RAISIN_100_ISABELLINE};
          color: ${darkModeColors.ISABELLINE_RAISIN_100};

          border: "none";
        }

        &:disabled {
          background: transparent;
          color: ${darkModeColors.RAISIN_50_RAISIN_80};
          border-color: ${darkModeColors.RAISIN_50_RAISIN_80};

          pointer-events: none;
          cursor: default;
        }

        &:first-of-type {
          background: ${darkModeColors.RAISIN_100_ISABELLINE};
          color: ${darkModeColors.ISABELLINE_RAISIN_100};
          border: none;

          &:hover {
            background: ${darkModeColors.RAISIN_80_ISABELLINE_DARKER};
          }

          &:active {
            background: ${colors.TURQUOISE_100};
            color: ${darkModeColors.ISABELLINE_RAISIN_100};
            border: none;
          }

          &:disabled {
            background: ${colors.RAISIN_50};
            color: ${colors.WHITE};
            border-color: unset;
          }
        }
      }
    }
  }

  .editor {
    ${(props) =>
      props.small &&
      `
      padding-top: 50px;
      overflow: scroll;
    `}

    box-sizing: border-box;
    height: ${(props) => (props.small ? "100%" : "419px")};
    margin: 18px 0;
    margin-right: 4px;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      line-height: 1.4;
    }

    a {
      color: ${colors.BLUE};
      text-decoration: underline;
    }

    .rdw-link-decorator-icon {
      width: 100%;
      height: 100%;
      left: 0;
      background: transparent;

      opacity: 0;
    }

    * {
      transition: 0s all !important;
    }

    .public-DraftEditor-content {
      height: 100%;
      padding-left: 14px;
      padding-right: 6px;
    }

    .public-DraftEditorPlaceholder-inner {
      padding-left: 14px;
      padding-right: 6px;
      color: ${colors.RAISIN_50};
    }
  }

  ${(props) => props?.viewOnly && ViewOnlyStyles};

  ${Paragraph2} {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 8px;
  }
`;
